'use client';

import { c as _c } from "react/compiler-runtime";
import { Carousel } from '@module/mdrt-org/shared/components/carousel/carousel';
import { LearnHeroCarouselGraphics } from '@shared/ui-components/svgs';
import { type BookmarkButtonCmsContent } from '../../../../components/bookmark-button/get-bookmark-button-cms-content';
import { type ShareDropdownCmsContent } from '../../../../components/share-dropdown/get-share-dropdown-cms-content';
import { type LearnContentCarouselCardFragment } from '../../../../utils/data/graphql/_generated/gql-generated';
import { type Bookmark } from '../../../../utils/types/bookmark';
import { LearnHeroCarouselCard } from './components/learn-hero-carousel-card/learn-hero-carousel-card';
import styles from './learn-hero-carousel.module.scss';
export type LearnHeroCarouselProps = {
  bookmarkButtonCmsContent: BookmarkButtonCmsContent;
  bookmarks: Bookmark[];
  cards: LearnContentCarouselCardFragment[];
  minutesLabel: string;
  shareDropdownCmsContent: ShareDropdownCmsContent;
  viewActionLabel: string;
};
export const LearnHeroCarousel = t0 => {
  const $ = _c(17);
  const {
    bookmarkButtonCmsContent,
    bookmarks,
    cards,
    minutesLabel,
    shareDropdownCmsContent,
    viewActionLabel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LearnHeroCarouselGraphics className={styles["carousel-graphics"]} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      all: {
        breakpoint: {
          max: Number.POSITIVE_INFINITY,
          min: 0
        },
        items: 1,
        partialVisibilityGutter: 0
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== bookmarkButtonCmsContent || $[3] !== bookmarks || $[4] !== cards || $[5] !== minutesLabel || $[6] !== shareDropdownCmsContent || $[7] !== viewActionLabel) {
    let t4;
    if ($[9] !== bookmarkButtonCmsContent || $[10] !== bookmarks || $[11] !== minutesLabel || $[12] !== shareDropdownCmsContent || $[13] !== viewActionLabel) {
      t4 = card => card && <div key={card?.ContentLink?.GuidValue}><LearnHeroCarouselCard bookmarkButtonCmsContent={bookmarkButtonCmsContent} card={card} isBookmarked={bookmarks?.some(bookmark => bookmark.bookmarkId === card.ContentLink?.GuidValue)} minutesLabel={minutesLabel} shareDropdownCmsContent={shareDropdownCmsContent} viewActionLabel={viewActionLabel} /></div>;
      $[9] = bookmarkButtonCmsContent;
      $[10] = bookmarks;
      $[11] = minutesLabel;
      $[12] = shareDropdownCmsContent;
      $[13] = viewActionLabel;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = cards.map(t4);
    $[2] = bookmarkButtonCmsContent;
    $[3] = bookmarks;
    $[4] = cards;
    $[5] = minutesLabel;
    $[6] = shareDropdownCmsContent;
    $[7] = viewActionLabel;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[15] !== t3) {
    t4 = <div className={styles["carousel-wrapper"]}><div className={styles["carousel-inner"]}>{t1}<Carousel arrowsClassName={styles["carousel-arrows"]} className={styles.carousel} deviceType="all" headerClassName={styles["carousel-header"]} responsive={t2} withDefaultResponsiveConfig={false}>{t3}</Carousel></div></div>;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};